import { SOCIAL_MEDIA_URLS } from "../assets/data/SocialMediaUrls";

export const useSocialMediaURLs = () => {
    return SOCIAL_MEDIA_URLS;
}
